import { ColumnDef } from "@tanstack/react-table";
import { DetailedUserWithStats } from "@/user/user.d";

export const EmailCol = (): ColumnDef<DetailedUserWithStats> => ({
  header: "Email",
  accessorFn: (row) => row.email,
});
